const RelatedResourceInit = () => {
    const mainPattern = document.querySelectorAll('.gg-related-resource');
    mainPattern.forEach((module) => {
      const articles = module.querySelectorAll('article');
      const items = module.querySelectorAll('.gravity-block-dynamic-boxes__box a');
      articles.forEach((article, index) => {
        article.classList.add('fade-in-up', `delay-${index}`);
      });
      items.forEach((item) => {
        const externalLink =  item.querySelector('.gravity-block-dynamic-boxes__presses-external-link')
        if(externalLink && externalLink.textContent != ''){
          item.setAttribute('target', '_blank');
        }
      });
    });
  }
  RelatedResourceInit();
  